import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WrappedHeader from './WrappedHeader';
import BrowserDetector from './BrowserDetector';
import UserData from './UserData';
import PartnerData from './PartnerData';
import ContactsPanel from '../common/ContactsPanel/ContactsPanel';
import SomethingWentWrongMessage from './SomethingWentWrongMessage';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, errorInfo: info });
  }

  render() {

    if(this.state.hasError) {
      return (
        <div className='rebrand'>
          <SomethingWentWrongMessage />
        </div>
      );
    }

    return (
      <div className='app rebrand'>
        <UserData />
        <PartnerData />
        <WrappedHeader />
        <BrowserDetector />
        <div className="app__content columns">
          {this.props.children}
        </div>
        <ContactsPanel/>
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired
};

export default App;
